"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const RemoveCircleRounded_1 = __importDefault(require("@mui/icons-material/RemoveCircleRounded"));
const ButtonDrag_1 = __importDefault(require("../../../global/Button/ButtonDrag"));
const ButtonIconSolo_1 = __importDefault(require("../../../global/Button/ButtonIconSolo"));
const ArrayOfPrimitivesItem = ({ children, className, disabled, fixedItemCount, hasMoveDown, hasMoveUp, hasRemove, index, onDropIndexClick, totalItems, uniqueId, }) => {
    // allow dragging the item if RJSF has indicated it is movable OR
    // it will become movable when additional items are added (ie. it isn't one of the fixed items).
    const nonFixedItemCount = totalItems - fixedItemCount;
    const isDraggable = hasMoveUp || hasMoveDown || index >= fixedItemCount;
    const canReorder = isDraggable && !disabled && nonFixedItemCount > 1;
    const hideLabel = index >= fixedItemCount;
    const classes = (0, clsx_1.default)(className, hideLabel && 'hide-labels', 'flex items-start gap-x-1 mb-2 hide-while-drag');
    if (!isDraggable) {
        // don't want to render the Draggable if the item can't be dragged as other items which can be dragged
        // can cause weird UI and other behavior.
        return react_1.default.createElement("div", { className: classes }, children);
    }
    return (react_1.default.createElement(react_beautiful_dnd_1.Draggable, { draggableId: `draggable-${uniqueId}`, index: index, isDragDisabled: !canReorder }, (provided) => (react_1.default.createElement("div", { ref: provided.innerRef, ...provided.draggableProps, className: classes },
        react_1.default.createElement(ButtonDrag_1.default, { canReorder: canReorder, dragHandle: provided, className: "mr-1" }),
        children,
        hasRemove && (react_1.default.createElement(ButtonIconSolo_1.default, { "aria-label": "Delete", tooltip: "Delete", disabled: disabled, onClick: onDropIndexClick(index) },
            react_1.default.createElement(RemoveCircleRounded_1.default, null)))))));
};
exports.default = ArrayOfPrimitivesItem;
